import { Col, Popover, Row, Spin } from 'antd';
import { alarmApi } from 'api/alarmApi';
import { plantApi } from 'api/plantApi';
import { useAppDispatch } from 'app/hooks';
import { sidebarActions } from 'components/Common/Sidebar/sidebarSlice';
import { ListResponse, maintenance, plantInfo, ResponseData } from 'models';
import { alarmInfo } from 'models/alarm';
import moment from 'moment';
import * as React from 'react';
import { AiFillSetting } from 'react-icons/ai';
import { FiClock } from 'react-icons/fi';
import { IoMdNotifications } from 'react-icons/io';
import { history } from 'utils';
import style from './ItemPlants.module.scss';
export interface ItemPlantProps {
  item: plantInfo;
}

export default function ItemPlant({ item }: ItemPlantProps) {
  const [energy, setEnergy] = React.useState<number>(0);
  const [estimated, setEstimated] = React.useState<number>(0);
  const [maintenance_info, setMaintenance_info] = React.useState<number>(0);
  const [total_elements, setTotal_elements] = React.useState<number>(0);
  const [newItem, setNewItem] = React.useState<plantInfo | undefined>(undefined);
  const thisMonth = moment().format('YYYY-MM');
  const dispatch = useAppDispatch();
  React.useEffect(() => {
    (async () => {
      try {
        const responseFive: ListResponse<alarmInfo> = await alarmApi.fetchAlarmList({
          type_Filter: 'ASSET',
          id: item.id,
          severity: 'ALL',
          active_or_cleared: 'ACTIVE',
          acknowledged_or_unacknowledged: 'ALL',
          start_ts: 0,
          end_ts: end_ts,
          _limit: 20,
          _page: 0,
        });
        setTotal_elements(responseFive.total_elements);
        const responseOne: ResponseData[] = await plantApi.fetchInfoPropertiesEnergy({
          type: 'output-energy',
          // properties: 'daily',
          properties: 'month',
          id: item.id,
          time: thisMonth,
        });
        setEnergy(getOutPut(responseOne));
        const responseTwo: ResponseData[] = await plantApi.fetchInfoPropertiesEnergy({
          type: 'estimated-output-energy',
          id: item.id,
          time: thisMonth,
          properties: 'month',
        });
        setEstimated(getOutPut(responseTwo));
        const responseThree: plantInfo = await plantApi.fetchPlantInfo({
          type: 'plant_id',
          id: item.id,
        });
        setNewItem(responseThree);
        const responseFour: maintenance = await plantApi.fetchMaintenanceInfo({
          type: 'maintenance-plan',
          id: item.id,
        });
        setMaintenance_info(responseFour.time);
        // const end_ts = moment(moment(moment().add(1, 'M')).format('YYYY-MM-DD')).valueOf();
      } catch (error) {
        console.log('Failed to fetch plant details', error);
      }
    })();
  }, []);

  const end_ts = moment(moment(moment().add(1, 'M')).format('YYYY-MM-DD')).valueOf();
  React.useEffect(() => {
    const interval = setInterval(async () => {
      const responseFive: ListResponse<alarmInfo> = await alarmApi.fetchAlarmList({
        type_Filter: 'ASSET',
        id: item.id,
        severity: 'ALL',
        active_or_cleared: 'ACTIVE',
        acknowledged_or_unacknowledged: 'ALL',
        start_ts: 0,
        end_ts: end_ts,
        _limit: 20,
        _page: 0,
      });
      setTotal_elements(responseFive.total_elements);
    }, 30000);
    return () => clearInterval(interval);
  }, []);

  const getOutPut = (array: ResponseData[]) => {
    const start_ts = moment(moment().format('YYYY-MM-DD')).valueOf();
    let newValue = 0;
    // array.map((i) => {
    array.forEach((i) => {
      if (i.ts === start_ts) {
        var output_value = i.value ? i.value / 1000 : 0;
        newValue = output_value;
      }
    });
    return newValue;
  };

  const onChangePlant = (id: string) => {
    localStorage.setItem('plantItemSidebar', id);
    localStorage.setItem('inverterItemSidebar', '');
    localStorage.setItem('isValueNavPlant', '1');
    dispatch(sidebarActions.setPlantItemSidebarList(id));
    const path = `/plant/home/${id}`;
    history.push(path);
  };
  const onChangeAlarmPlant = (id: string) => {
    localStorage.setItem('plantItemSidebar', id);
    localStorage.setItem('inverterItemSidebar', '');
    localStorage.setItem('isValueNavPlant', '4');
    dispatch(sidebarActions.setPlantItemSidebarList(id));
    const path = `/plant/alarm/${id}`;
    history.push(path);
  };

  const formatDate = (number: number) => {
    let date = moment(moment().add(2, 'days')).valueOf();
    let day = moment(moment()).valueOf();
    if (number >= date) {
      return 1;
    } else if (number >= day && number < date) {
      return 2;
    } else {
      return 3;
    }
  };

  const percentEnergy = (energy: number, estimated: number) => {
    return (energy / estimated) * 100;
  };

  const content = () => (
    <>
      {formatDate(maintenance_info) === 1 ? (
        <div>Planned</div>
      ) : formatDate(maintenance_info) === 2 ? (
        <div>Soon</div>
      ) : (
        <div>Over due</div>
      )}
    </>
  );

  return (
    <>
      {newItem ? (
        <Col className={style.item_plant}>
          <Row align={'middle'} justify={'space-between'} className={style.header_item_plant}>
            <Row align={'middle'} className={style.title_item_plant}>
              <Row
                align={'middle'}
                justify={'center'}
                className={style.total_alarms}
                style={{
                  backgroundColor: total_elements === 0 ? '#61C409' : 'red',
                }}
              ></Row>
              <div className={style.lable_items_plant} onClick={() => onChangePlant(item.id)}>
                {item.label}
              </div>
            </Row>
            <Row align={'middle'} justify={'space-between'}>
              <Row
                align={'middle'}
                className={style.maintenance_info}
                style={{
                  display: maintenance_info !== undefined ? 'flex' : 'none',
                  backgroundColor:
                    formatDate(maintenance_info) === 1
                      ? '#cecece'
                      : formatDate(maintenance_info) === 2
                      ? '#DFBE10'
                      : '#540000',
                }}
              >
                <FiClock size={15} />
                <div className={style.content_maintenance}>
                  {moment(maintenance_info).format('YYYY-MM-DD')}
                </div>
                <Popover placement="bottomRight" content={content} trigger="hover">
                  <AiFillSetting size={15} />
                </Popover>
              </Row>
              <Row
                align={'middle'}
                className={style.maintenance_info}
                style={{
                  marginLeft: '10px',
                  display: total_elements !== 0 ? 'flex' : 'none',
                  backgroundColor: 'red',
                }}
                onClick={() => onChangeAlarmPlant(item.id)}
              >
                <Row
                  align={'middle'}
                  justify={'center'}
                  style={{
                    padding: '0 5px',
                    fontSize: '15px',
                  }}
                >
                  {total_elements <= 99 ? `${total_elements}` : `${total_elements}+`}
                </Row>
                <IoMdNotifications size={18} />
              </Row>
            </Row>
          </Row>
          <div className={style.container_item_plant}>
            <div className={style.content_items_plant}>
              <div>
                <span className={style.title_detail_item}>System size:</span>
                <span className={style.value_detail_item}>
                  {newItem ? `${newItem.system_size} kWh` : 'N/A'}
                </span>
              </div>
              <div>
                <span className={style.title_detail_item}>Installation date:</span>
                <span className={style.value_detail_item}>
                  {newItem?.installation_date !== undefined
                    ? moment(newItem?.installation_date).format('YYYY-MM-DD')
                    : 'N/A'}
                </span>
              </div>
              <div>
                <span className={style.title_detail_item}>Address:</span>
                <span className={style.value_detail_item}>
                  {newItem?.address !== undefined ? newItem.address : 'N/A'}
                </span>
              </div>
              <div>
                <span className={style.title_detail_item}>Today output energy:</span>
                <span
                  style={{
                    color: 'yellowgreen',
                    fontWeight: 600,
                  }}
                >
                  {energy !== 0 ? energy : 'N/A'} kWh
                </span>
              </div>
              <div>
                <span className={style.title_detail_item}>Today PR:</span>
                <div className={style.progressBar}>
                  <div
                    style={{
                      display: energy === 0 || estimated === 0 ? 'none' : 'flex',
                      alignItems: 'center',
                      justifyContent: 'flex-end',
                      fontSize: '12px',
                      padding: '0px 5px',
                      height: '100%',
                      width:
                        percentEnergy(energy, estimated) <= 100
                          ? `${percentEnergy(energy, estimated)}%`
                          : '100%',
                      backgroundColor: '#61C409',
                      color: ' #fff',
                      marginBottom: 0,
                    }}
                  >
                    {percentEnergy(energy, estimated) > 40 && (
                      <span>
                        {energy !== 0
                          ? `${percentEnergy(energy, estimated).toLocaleString(undefined, {
                              maximumFractionDigits: 2,
                            })} %`
                          : ''}
                      </span>
                    )}
                  </div>
                  {percentEnergy(energy, estimated) <= 40 && (
                    <span
                      style={{
                        marginLeft: '5px',
                      }}
                    >
                      {energy !== 0
                        ? `${percentEnergy(energy, estimated).toLocaleString(undefined, {
                            maximumFractionDigits: 2,
                          })} %`
                        : ''}
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Col>
      ) : (
        <div className={style.spin_loading}>
          <Spin tip="Loading..."></Spin>
        </div>
      )}
    </>
  );
}
